/* eslint-disable */
import { SVGProps } from "react";
const SvgRoofing = (props:SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16.762}
    height={16.252}
    fill="currentColor"
    viewBox="0 0 16.762 16.252"
    {...props}
  >
    <g data-name="Group 970">
      <g data-name="Group 969" >
        <path data-name="Path 881" d="M2.934 13.558h5.147V9.239Z" />
        <path data-name="Rectangle 698" d="M0 15.354h16.762v.898H0z" />
        <path
          data-name="Path 882"
          d="m9.581 7.981 5.578 5.578h.406v-.442l-5.523-5.523Z"
        />
        <path data-name="Path 883" d="M1.508 14.756h15.251v-.6H2.221Z" />
        <path data-name="Path 884" d="m9.121 8.367-.441.37v4.822h.6V8.52Z" />
        <path data-name="Path 885" d="M16.164 13.561h.6v-11.6l-.6.5Z" />
        <path
          data-name="Path 886"
          d="M0 14.066v.689h.577L1.9 13.647l6.268-5.26 8.591-7.21V0Z"
        />
        <path data-name="Path 887" d="m15.565 2.959-5.062 4.248 5.062 5.062Z" />
        <path data-name="Path 888" d="M14.313 13.558 9.878 9.123v4.435Z" />
      </g>
    </g>
  </svg>
);

export default SvgRoofing;
